// extracted by mini-css-extract-plugin
module.exports = {"video-edit-button":"styles_video-edit-button__ZTv_y","edit-active":"styles_edit-active__3PHmM","edit-inactive":"styles_edit-inactive__3I0xO"};